<section class="hero">
  <div>
    <p class="eyebrow">Overview</p>
    <h1>Review pulse</h1>
  </div>

  @if (data(); as overview) {
    <div class="range-chip">
      <span>{{ overview.dateRange.from | localDate:'date' }}</span>
      <span>to</span>
      <span>{{ overview.dateRange.to | localDate:'date' }}</span>
    </div>
  }
</section>

@if (data(); as overview) {
  @if (hasOverviewActivity()) {
  <section class="metric-grid">
    <app-metric-card label="Repositories" [value]="overview.totals.repositoriesInScope" hint="Active in current window" />
    <app-metric-card label="PRs Reviewed" [value]="overview.totals.pullRequestsReviewed" hint="Completed reviews" />
    <app-metric-card label="Issues Found" [value]="overview.totals.issuesFound" hint="Across all runs" tone="warn" />
    <app-metric-card label="Block Rate" [value]="((overview.totals.blockRate | number:'1.1-1') ?? '0') + '%'" hint="Verdicts marked blocked" tone="danger" />
    <app-metric-card label="Avg Issues / PR" [value]="(overview.totals.avgIssuesPerPullRequest | number:'1.1-2') ?? '0'" hint="Backend-computed ratio" />
    <app-metric-card label="Review Runs" [value]="overview.totals.completedReviewRuns" hint="Completed AI review executions" />
  </section>

  <section class="content-grid">
    <article class="panel chart-panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Verdicts</p>
          <h2>Outcome mix</h2>
        </div>
      </div>
      <div class="chart-shell">
        <canvas
          baseChart
          [data]="verdictChartData()"
          [type]="'doughnut'"
          [options]="{ maintainAspectRatio: false, plugins: { legend: { position: 'bottom' } }, cutout: '72%' }">
        </canvas>
      </div>
    </article>

    <article class="panel chart-panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Issue Categories</p>
          <h2>Where comments cluster</h2>
        </div>
      </div>
      @if (overview.categoryBreakdown.length) {
        <div class="chart-shell">
          <canvas
            baseChart
            [data]="categoryChartData()"
            [type]="'bar'"
            [options]="{
              maintainAspectRatio: false,
              plugins: { legend: { display: false } },
              scales: { y: { beginAtZero: true, ticks: { precision: 0 } } }
            }">
          </canvas>
        </div>
      } @else {
        <div class="panel-empty">
          <strong>No category signals</strong>
          <span>The selected range did not produce categorized review comments.</span>
        </div>
      }
    </article>
  </section>

  @if (overview.topRepositories.length) {
    <section class="panel">
      <div class="panel-head">
        <div>
          <p class="panel-kicker">Repositories</p>
          <h2>Highest issue load</h2>
        </div>
        <a routerLink="/repositories" class="panel-link">Open repositories</a>
      </div>

      <div class="table-shell">
        <table>
          <thead>
            <tr>
              <th>Repository</th>
              <th>Project</th>
              <th>PRs</th>
              <th>Issues</th>
              <th>Block Rate</th>
            </tr>
          </thead>
          <tbody>
            @for (repository of overview.topRepositories; track repository.repositoryId) {
              <tr>
                <td>
                  <a [routerLink]="['/repositories', repository.repositoryId]">{{ repository.repositoryName }}</a>
                </td>
                <td>{{ repository.projectName }}</td>
                <td>{{ repository.pullRequestsReviewed }}</td>
                <td>{{ repository.issuesFound }}</td>
                <td>{{ repository.blockRate | number:'1.1-1' }}%</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
  } @else {
    <section class="state-card">
      <p>No review activity was found for the selected range.</p>
    </section>
  }
} @else if (loading()) {
  <section class="state-card">Loading overview metrics…</section>
} @else if (error()) {
  <section class="state-card error">
    <p>{{ error() }}</p>
    <button type="button" class="state-button" (click)="load()">Try again</button>
  </section>
} @else {
  <section class="state-card">
    <p>No overview data returned for the selected range.</p>
  </section>
}
